import React, { Component } from 'react';

export default class ZSelectField extends Component {

    //Props List
    /*
        id,
        className,
        placeholder,
        defaultValue,
        menuItems,
        simplifiedMenu,
        onChange,
        value,
        isBlocked
    */

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            sequenceNum: 0,
            activeItem: this.props.defaultValue
        }

        this.nextSequence = this.nextSequence.bind(this);

        this.generateMenuItems = this.generateMenuItems.bind(this);
    }

    componentDidMount() { }

    componentWillReceiveProps() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value != this.state.activeItem) {
            this.setState({ activeItem: this.props.value });
        }
    }

    nextSequence() {
        let self = this;

        let num = this.state.sequenceNum;

        if (this.state.sequenceNum === 2) {
            num = 0;
        } else {
            num++;
        }

        this.setState({ sequenceNum: num }, () => {
            if (num === 2) {
                setTimeout(() => {
                    self.nextSequence();
                }, 150);
            }
        });
    }

    generateMenuItems() {
        let self = this;
        if (this.props.menuItems === undefined || this.props.menuItems === null) {
            return null;
        }

        let menuItems = [];

        for (var i = 0; i < this.props.menuItems.length; i++) {

            let tempItem = this.props.menuItems[i];
            let showItem = this.props.menuItems[i];
            let blurClass = '';
            if (this.props.isBlurred && tempItem != this.props.meKey) {
                showItem = "Jane Smith";
                blurClass += ' text-blurred';
            }

            let itmeStyle = {}
            if (this.props.menuItems[i] === this.state.activeItem) {
                itmeStyle.color = this.props.activeColor;
            }

            menuItems.push((
                <div className={"zmd-item" + blurClass} style={itmeStyle}
                    onClick={
                        () => {
                            if (self.state.sequenceNum === 1) {
                                self.nextSequence();
                                self.setState({ activeItem: tempItem }, () => {
                                    if (self.props.parameters != undefined && self.props.parameters != null) {
                                        self.props.onChange(tempItem, self.props.parameters[0], self.props.parameters[1]);
                                    } else {
                                        self.props.onChange(tempItem)
                                    }
                                });
                            }
                        }}>
                    {showItem}
                </div>
            ));

        }

        return menuItems;
    }

    render() {

        let outerClass = "zmd-selectfield-outer";
        let itemContainerClass = 'zmd-item-container';
        let blockerClass = 'zmd-blocker'

        switch (this.state.sequenceNum) {
            case 0:
                break;
            case 1:
                blockerClass += ' zmd-blocker--active';
                itemContainerClass += ' zmd-item-container--phase1';
                break;
            case 2:
                blockerClass += ' zmd-blocker--active';
                itemContainerClass += ' zmd-item-container--phase2';
                break;
        }

        if (this.props.className != undefined) {
            outerClass += ' ' + this.props.className;
        }


        let blockJsx = !this.props.isBlocked ? null :
            (
                <div className={blockerClass}
                    onClick={this.state.sequenceNum === 1 ? this.nextSequence : null}
                    onScroll={this.state.sequenceNum === 1 ? this.nextSequence : null}></div>
            )

        let menuItems = this.generateMenuItems();

        let labelStyle = {};
        if (this.state.activeItem === undefined || this.state.activeItem === null) {
            labelStyle.color = 'rgba( 0, 0, 0, 0.35)';
        }

        let displayText = this.state.activeItem != undefined && this.state.activeItem != null ? this.state.activeItem + ' ' : this.props.placeholder;
        let blurClass = '';
        if (this.props.isBlurred && this.state.activeItem != this.props.meKey) {
            displayText = "Jane Smith";
            blurClass += ' text-blurred-white';
        }

        return (
            <div id={this.props.id} className={outerClass}>
                {blockJsx}
                <div className={"zmd-selectfield-label" + blurClass} style={labelStyle} onClick={() => { if (this.state.sequenceNum === 0) { this.nextSequence(); } }}>
                    {displayText}
                    <div className="material-icons zmd-selectfield-arrow">arrow_drop_down</div>
                </div>
                <div className={itemContainerClass}>
                    {menuItems}
                </div>
            </div>
        );
    }
}
